import React, { useState, Component } from 'react';
import { CalendarIcon, ClockIcon, CheckCircleIcon, VideoIcon, AlertTriangleIcon, ChevronRightIcon, GiftIcon, TargetIcon, ZapIcon, ShieldCheckIcon, UsersIcon, ChevronDownIcon } from 'lucide-react';
import { RegistrationModal } from './RegistrationModal';
import { TestimonialsCarousel } from './TestimonialsCarousel';
import { FeaturedTestimonials } from './FeaturedTestimonials';
import { CountdownBar } from './CountdownBar';
import { SocialProofToast } from './SocialProofToast';
export function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  return <div className="min-h-screen bg-brand-bg text-white font-sans overflow-x-hidden" data-id="element-37">
      {/* A) BARRA SUPERIOR FIJA (ALERTA) */}
      <CountdownBar data-id="element-38" />

      {/* Spacer for fixed header */}
      <div className="h-10" data-id="element-39"></div>

      {/* B) HERO SECTION */}
      <section className="relative bg-brand-bg overflow-hidden min-h-[80vh] md:min-h-[85vh] flex items-center justify-center" data-id="element-40">
        <div className="relative z-10 max-w-4xl mx-auto px-5 py-16 md:py-20 text-center flex flex-col items-center" data-id="element-41">
          {/* Cyan accent bar */}
          <div className="mb-4" data-id="element-42"></div>

          {/* Live badge */}
          <div className="mb-4 inline-flex items-center gap-2 bg-brand-cyan/10 border border-brand-cyan/30 text-brand-cyan font-black text-xs md:text-sm px-4 py-1.5 rounded-full tracking-wide uppercase" data-id="element-43">
            <span className="w-2 h-2 bg-red-600 rounded-full animate-pulse inline-block" data-id="element-44"></span>
            En vivo por Zoom
          </div>

          {/* Date/time badge */}
          <div className="mb-8 inline-flex items-center bg-brand-card/80 border border-gray-700 text-gray-300 font-semibold text-sm md:text-base px-5 py-2 rounded-full pt-[5px] pb-[5px] pl-[10px] pr-[10px] gap-[5px]" data-id="element-45">
            <CalendarIcon className="w-4 h-4 text-brand-gold" data-id="element-46" />
            <span data-id="element-47">Jueves 12 de Marzo - 20:00 hs (Argentina)</span>
          </div>

          {/* Main headline */}
          <h1 className="font-black tracking-tight mb-6 text-white md:text-4xl lg:text-5xl max-w-4xl mx-auto text-[25px]" data-id="element-48">
            El Sistema{' '}
            <span className="text-brand-gold" data-id="element-49">Más Simple y Rápido</span> Para
            Generar{' '}
            <span className="text-brand-gold" data-id="element-50">
              Ingresos Digitales En Automático
            </span>{' '}
            <span className="text-brand-cyan" data-id="element-51">
              Sin Saber Sobre Ventas, Diseño, Programación
            </span>{' '}
            Ni Crear Contenido Todos Los Días.
          </h1>

          {/* Subheadline */}
          <p className="text-gray-300 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-52">
            En esta clase en vivo te mostraré cómo usar inteligencia artificial
            + e-commerce para crear un sistema simple y rápido de ventas
            digitales, aunque hoy estés empezando desde cero.
          </p>

          {/* 3 Bullets */}

          {/* Chips */}

          {/* CTA Button */}
          <div className="flex flex-col items-center gap-3 w-full max-w-md mx-auto mb-6" data-id="element-53">
            <button onClick={openModal} className="w-full bg-brand-gold hover:bg-yellow-400 text-brand-bg font-black text-lg md:text-xl py-5 px-12 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 group" data-id="element-54">
              QUIERO APRENDER ESTO
            </button>
            <p className="text-brand-gold/70 text-sm font-medium" data-id="element-55">
              Recibí el acceso a esta clase ahora
            </p>
          </div>

          {/* Warning line */}
          <div className="flex items-center justify-center gap-2 text-gray-500 text-sm mt-4" data-id="element-56">
            <AlertTriangleIcon className="w-4 h-4 text-brand-gold" data-id="element-57" />
            <span data-id="element-58">
              Registros limitados: la sala de Zoom solo admite 100 personas en
              vivo
            </span>
          </div>
        </div>
      </section>

      {/* F) TESTIMONIOS (MOVED UP) */}
      <section className="py-16 bg-brand-bg overflow-hidden" data-id="element-59">
        <div className="text-center mb-10 px-4" data-id="element-60">
          <p className="text-brand-cyan text-xs font-bold uppercase tracking-widest mb-3" data-id="element-61">
            Resultados reales aplicando el Sistema AIC (AI-Commerce)
          </p>
          <h2 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-62">
            Casos reales de alumnos
          </h2>
          <p className="text-gray-400" data-id="element-63">
            Personas comunes ejecutando un sistema claro.
          </p>
        </div>

        {/* 1. General Carousel (Marquee) - Moved to top */}
        <div className="mb-8" data-id="element-64">
          <TestimonialsCarousel data-id="element-65" />
        </div>

        {/* 2. Featured Stories (Video/Image Grid + New Freedom Section) */}
        <FeaturedTestimonials onOpenModal={openModal} data-id="element-66" />
      </section>

      {/* C) SECCIÓN: LO QUE TE LLEVÁS */}
      <section className="py-12 px-4 bg-brand-card/30 border-y border-gray-800" data-id="element-67">
        <div className="max-w-4xl mx-auto" data-id="element-68">
          <div className="text-center mb-10" data-id="element-69">
            <h2 className="text-2xl md:text-3xl font-bold mb-2 flex items-center justify-center gap-2" data-id="element-70">
              <GiftIcon className="w-8 h-8 text-brand-cyan" data-id="element-71" />
              Lo que te llevás por registrarte
            </h2>
            <p className="text-gray-400" data-id="element-72">
              Material exclusivo solo para asistentes en vivo
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-73">
            {[{
            label: 'Acceso inmediato',
            title: '🎥 Masterclass en vivo',
            desc: 'Acceso a la masterclass en vivo donde te muestro el Sistema AIC paso a paso.',
            icon: <VideoIcon className="w-5 h-5 text-brand-gold" data-id="element-74" />
          }, {
            label: 'Solo asistentes en vivo',
            title: '🗺 Mapa AIC',
            desc: 'La hoja de ruta del sistema. El paso a paso visual para que entiendas cómo lanzar y validar sin improvisar.',
            icon: <TargetIcon className="w-5 h-5 text-brand-cyan" data-id="element-75" />
          }, {
            label: 'Solo asistentes en vivo',
            title: '✅ Checklist + Plantillas + Prompts de IA',
            desc: 'Checklist de implementación paso a paso, plantillas de landing pages y prompts de IA listos para usar.',
            icon: <CheckCircleIcon className="w-5 h-5 text-brand-gold" data-id="element-76" />
          }, {
            label: 'Acceso exclusivo',
            title: '🔒 Formación AI-Commerce',
            desc: 'Explicación de cómo entrar a la formación AI-Commerce si querés aplicar el sistema con acompañamiento.',
            icon: <UsersIcon className="w-5 h-5 text-brand-cyan" data-id="element-77" />
          }].map((item, i) => <div key={i} className="bg-brand-bg border border-gray-800 p-4 rounded-xl flex flex-col gap-2 hover:border-brand-cyan/50 transition-colors relative overflow-hidden group" data-id="element-78">
                {/* Micro-label */}
                <div className="absolute top-0 right-0 bg-brand-gold/10 px-2 py-1 rounded-bl-lg border-b border-l border-brand-gold/20" data-id="element-79">
                  <span className="text-[10px] font-bold text-brand-gold uppercase tracking-wider" data-id="element-80">
                    {item.label}
                  </span>
                </div>

                <div className="flex items-start gap-3 mt-2" data-id="element-81">
                  <div className="p-2 bg-brand-card rounded-lg border border-gray-700 flex-shrink-0 mt-1" data-id="element-82">
                    {item.icon}
                  </div>
                  <div data-id="element-83">
                    <h3 className="font-black text-base text-white mb-1 leading-tight" data-id="element-84">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 text-xs leading-snug" data-id="element-85">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* D) ¿PARA QUIÉN ES ESTA MASTERCLASS? */}
      <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-86">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-87">
          ¿Para quién es esta Masterclass?
        </h2>

        {/* Es para ti si */}
        <p className="text-brand-cyan font-bold text-sm uppercase tracking-wider mb-4" data-id="element-88">
          Es para ti si:
        </p>
        <div className="space-y-3 mb-10" data-id="element-89">
          {['Eres empleado o emprendedor tradicional y quieres un ingreso digital real.', 'Buscas un sistema claro y ejecutable.', 'No sabes de marketing, diseño ni programación.', 'No quieres depender de crear contenido todos los días.', 'Estás dispuesto a ejecutar un paso a paso.'].map((text, i) => <div key={i} className="flex items-start gap-4 p-4 bg-brand-card/50 rounded-xl border border-gray-800" data-id="element-90">
              <div className="mt-1 min-w-[24px]" data-id="element-91">
                <CheckCircleIcon className="w-6 h-6 text-brand-cyan" data-id="element-92" />
              </div>
              <p className="text-gray-200 font-medium" data-id="element-93">{text}</p>
            </div>)}
        </div>

        {/* No es para ti si */}
        <p className="text-red-400 font-bold text-sm uppercase tracking-wider mb-4" data-id="element-94">
          No es para ti si:
        </p>
        <div className="space-y-3" data-id="element-95">
          {['Buscas dinero fácil sin trabajar.', 'Solo quieres motivación.', 'No estás dispuesto a seguir un método paso a paso.'].map((text, i) => <div key={i} className="flex items-start gap-4 p-4 bg-brand-card/30 rounded-xl border border-red-900/30" data-id="element-96">
              <div className="mt-1 min-w-[24px]" data-id="element-97">
                <AlertTriangleIcon className="w-5 h-5 text-red-400" data-id="element-98" />
              </div>
              <p className="text-gray-400 font-medium" data-id="element-99">{text}</p>
            </div>)}
        </div>
      </section>

      {/* E) LO QUE VAS A APRENDER */}
      <section className="py-16 px-4 bg-brand-card border-y border-gray-800" data-id="element-100">
        <div className="max-w-4xl mx-auto" data-id="element-101">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" data-id="element-102">
            Lo que vas a aprender en{' '}
            <span className="text-brand-gold" data-id="element-103">90 minutos</span>
          </h2>

          <div className="space-y-6" data-id="element-104">
            {[{
            title: 'Qué es realmente AI-Commerce',
            desc: 'Y por qué está cambiando el juego para personas comunes.'
          }, {
            title: 'Cómo detectar una idea rentable usando IA',
            desc: 'Sin adivinar. Con un proceso claro de validación.'
          }, {
            title: 'Cómo armar tu Sistema AIC paso a paso',
            desc: 'La estructura exacta para crear un flujo de ventas digitales.'
          }, {
            title: 'Cómo vender sin ser influencer',
            desc: 'Sin mostrar tu cara, sin crear contenido todos los días.'
          }, {
            title: 'Los errores que hacen que el 90% abandone',
            desc: 'Antes de ganar su primer ingreso digital.'
          }, {
            title: 'Qué haría yo si empezara desde cero hoy',
            desc: 'Plan concreto para implementar en las próximas 48 HORAS.'
          }].map((item, i) => <div key={i} className="flex gap-4 md:gap-6 items-start" data-id="element-105">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-bg border border-brand-cyan/30 flex items-center justify-center text-brand-cyan font-bold text-xl shadow-[0_0_15px_rgba(0,212,255,0.15)]" data-id="element-106">
                  {i + 1}
                </div>
                <div data-id="element-107">
                  <h3 className="text-lg md:text-xl font-bold text-white mb-1" data-id="element-108">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-sm md:text-base" data-id="element-109">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* G) SOBRE JUAN */}
      <section className="py-16 px-4 max-w-4xl mx-auto border-t border-gray-800" data-id="element-110">
        {/* Section Header */}
        <div className="text-center mb-10" data-id="element-111">
          <p className="text-brand-cyan text-xs font-bold uppercase tracking-widest mb-3" data-id="element-112">
            Tu mentor en AI-Commerce
          </p>
          <h2 className="text-2xl md:text-4xl font-black mb-2" data-id="element-113">
            ¿Quién será tu guía?
          </h2>
        </div>

        {/* Teaching Image — Right below the heading */}
        <div className="mb-10 relative rounded-2xl overflow-hidden border border-gray-800 shadow-2xl group" data-id="element-114">
          <img src="https://cdn.magicpatterns.com/uploads/p6G8CMJKsBWyGiKGNp31WM/Captura_de_pantalla_2026-03-03_a_las_2.48.46_p._m..png" alt="Juan Ciccarelli enseñando AI-Commerce en vivo" className="w-full h-56 md:h-80 object-cover object-center" data-id="element-115" />
          {/* Gradient overlay at bottom */}
          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-brand-bg/90 to-transparent pointer-events-none" data-id="element-116"></div>
          {/* Caption badge */}
          <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-md px-4 py-2 rounded-full border border-white/10" data-id="element-117">
            <span className="text-white text-xs font-bold tracking-wide uppercase" data-id="element-118">
              + 250 ALUMOS IMPACTADOS
            </span>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12" data-id="element-119">
          {/* Floating image — no border, no card, blends with dark bg */}
          <div className="w-full md:w-72 flex-shrink-0 relative" data-id="element-120">
            {/* Subtle bottom fade to blend with bg */}
            <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-brand-bg to-transparent pointer-events-none" data-id="element-121"></div>
          </div>
          <div className="text-center md:text-left flex flex-col justify-center" data-id="element-122">
            <div className="space-y-4 text-gray-300" data-id="element-123">
              <p data-id="element-124">
                Soy <strong className="text-white" data-id="element-125">Juan Ciccarelli</strong>,
                mentor en AI-Commerce. Hace más de 5 años vivo de vender
                productos digitales y he facturado más de{' '}
                <strong className="text-brand-gold" data-id="element-126">200.000 USD</strong>{' '}
                aplicando sistemas simples de venta online.
              </p>
              <p data-id="element-127">
                Durante años pensé que generar dinero online era solo para
                expertos o influencers. Hasta que estructuré un sistema simple
                basado en inteligencia artificial aplicada al e-commerce. Ese
                sistema hoy lo llamo:{' '}
                <strong className="text-brand-cyan" data-id="element-128">
                  Sistema AIC (AI-Commerce)
                </strong>
                .
              </p>
              <p data-id="element-129">
                IA aplicada a e-commerce para acelerar decisiones, validar ideas
                y crear ventas digitales con estructura.
              </p>
              <p data-id="element-130">
                En esta masterclass te enseñaré el Sistema AIC y al final te
                mostraré cómo podés entrar a mi formación AI-Commerce si querés
                implementarlo con estructura y acompañamiento.
              </p>
              <div className="flex flex-wrap justify-center md:justify-start gap-3 mt-4" data-id="element-131">
                <span className="px-3 py-1 bg-brand-card rounded-lg text-sm border border-gray-700 text-gray-400" data-id="element-132">
                  Sin promesas irreales
                </span>
                <span className="px-3 py-1 bg-brand-card rounded-lg text-sm border border-gray-700 text-gray-400" data-id="element-133">
                  Sistema ejecutable
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* CTA below bio */}
        <div className="mt-8 text-center md:text-left" data-id="element-134">
          <button onClick={openModal} className="w-full md:w-auto bg-brand-gold hover:bg-yellow-400 text-brand-bg font-black text-base py-3 px-8 rounded-xl shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 group" data-id="element-135">
            QUIERO VER EL SISTEMA EN VIVO
            <ChevronRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-136" />
          </button>
        </div>
      </section>

      {/* H) FAQ */}
      <section className="py-16 px-4 bg-brand-card/20" data-id="element-137">
        <div className="max-w-3xl mx-auto" data-id="element-138">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-139">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-3" data-id="element-140">
            {[{
            q: '¿Necesito conocimientos previos de programación o diseño?',
            a: 'No. Justamente el Sistema AIC utiliza Inteligencia Artificial para resolver la parte técnica y visual. Si sabés usar WhatsApp y navegar por internet, podés hacerlo.'
          }, {
            q: '¿Tengo que invertir dinero en publicidad?',
            a: 'Sí, vas a invertir para comenzar 5 USD en un anuncio que ya te puede traer ventas. Luego cuando validás, seguís escalando con lo mismo que vas generando.'
          }, {
            q: '¿Es necesario tener una computadora potente?',
            a: 'No. Podés gestionar gran parte del negocio desde tu celular, aunque una computadora básica (notebook o PC) facilita la configuración inicial de la tienda.'
          }, {
            q: '¿Cuánto dura la clase?',
            a: 'La sesión en vivo durará aproximadamente 90 minutos, incluyendo un espacio al final para responder preguntas en directo.'
          }, {
            q: '¿Queda grabada la clase?',
            a: 'No garantizamos la grabación. El contenido es de alto valor y está diseñado para ser consumido en vivo. Te recomendamos priorizar tu asistencia.'
          }, {
            q: '¿Vas a vender algo al final?',
            a: 'Sí. Primero compartiré contenido completo y estructurado. Al final presentaré mi formación AI-Commerce para quienes quieran aplicar el sistema con acompañamiento. Si no deseás comprar, igual podrás quedarte con el contenido de la clase y ya vas a saber más que el 90% de las personas sobre IA y E-commerce.'
          }].map((item, i) => <div key={i} className="border border-gray-800 rounded-xl bg-brand-bg overflow-hidden" data-id="element-141">
                <button onClick={() => toggleFaq(i)} className="w-full flex items-center justify-between p-5 text-left hover:bg-brand-card/50 transition-colors" data-id="element-142">
                  <span className="font-bold text-gray-200 pr-4" data-id="element-143">{item.q}</span>
                  <ChevronDownIcon className={`w-5 h-5 text-brand-cyan transition-transform duration-300 flex-shrink-0 ${openFaqIndex === i ? 'rotate-180' : ''}`} data-id="element-144" />
                </button>
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openFaqIndex === i ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-145">
                  <div className="p-5 pt-0 text-gray-400 border-t border-gray-800/50 mt-2" data-id="element-146">
                    {item.a}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* I) CTA FINAL */}
      <section className="py-20 px-4 text-center relative overflow-hidden" data-id="element-147">
        {/* Background effects */}
        <div className="absolute inset-0 bg-gradient-to-b from-brand-bg to-brand-card opacity-50" data-id="element-148"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-brand-gold/10 blur-[120px] rounded-full pointer-events-none" data-id="element-149"></div>

        <div className="relative z-10 max-w-2xl mx-auto" data-id="element-150">
          <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-151">
            Si no empezás ahora, <br data-id="element-152" />
            <span className="text-brand-gold" data-id="element-153">¿cuándo?</span>
          </h2>
          <p className="text-xl text-gray-300 mb-10" data-id="element-154">
            Este Jueves te mostraré el Sistema AIC en vivo. Si querés dejar de
            Depender de un empleo que te quita libertad y empezar con un Sistema
            real que no tiene Límites, reservá tu cupo ahora.
          </p>

          <button onClick={openModal} className="w-full md:w-auto bg-brand-gold hover:bg-yellow-400 text-brand-bg font-black text-xl py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all transform hover:-translate-y-1" data-id="element-155">
            RESERVAR MI CUPO GRATIS AHORA
          </button>

          <p className="mt-6 text-red-400 font-medium flex items-center justify-center gap-2 animate-pulse" data-id="element-156">
            <AlertTriangleIcon className="w-4 h-4" data-id="element-157" />
            Solo 100 lugares disponibles.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 text-center text-gray-600 text-sm border-t border-gray-900 bg-black" data-id="element-158">
        <p data-id="element-159">© 2026 AI-Commerce Masterclass. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-160">
          Este sitio no es parte de Facebook o Facebook Inc.
        </p>
      </footer>

      {/* Modal Component */}
      <RegistrationModal isOpen={isModalOpen} onClose={closeModal} data-id="element-161" />

      {/* Social Proof Toast */}
      <SocialProofToast data-id="element-162" />
    </div>;
}